import { render } from "./DefaultPieChart.vue?vue&type=template&id=00a79b10"
import script from "./DefaultPieChart.vue?vue&type=script&lang=js"
export * from "./DefaultPieChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__